import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import Typography from "@mui/material/Typography";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";

import { StyledSwitch } from "../../components/Base";
import Button from "../../components/Button";
import TableComponent from "../../components/TableComponent";
import { SignOffDateButton } from "../../features/training-sign-off-date";
import {
  getUsersInscribed,
  updateCheckingProgress,
  updateModuleStatus,
  updateStatusCertificate,
} from "../../api/training.deprecated";
import { isPracticalModuleCompleted, isTrainingCompleted } from "../../api/training";
import useUser from "../../hooks/useUser";
import useCrew from "../../hooks/useCrew";

const AssessorCheckingProgress = ({ match, history }) => {
  const { t } = useTranslation();
  const [usersInscribed, setUsersInscribed] = useState([]);
  const [refresh, setRefresh] = useState(1);
  const trainingId = match.params.trainingId;
  const instructorComplete = +match.params.instructorComplete;
  const assessorPassed = +match.params.assessorPassed;
  const checkerPassed = +match.params.checkerPassed;
  const evaluator = useUser();
  const { crew } = useCrew();

  useEffect(() => {
    (async () => {
      const usersInscribed = await getUsersInscribed(trainingId, crew.id, crew.baseIds);
      setUsersInscribed(usersInscribed);
    })();
  }, [refresh, crew]);

  const onEventSwitch = async (id, field, value, userInscribed) => {
    const res = await updateCheckingProgress(id, field, value, evaluator.id);

    const practical_status = isPracticalModuleCompleted({ instructorComplete, assessorPassed, checkerPassed }, res)
      ? 1
      : 0;
    const resAfterUpdateModule = await updateModuleStatus(id, "practical_status", practical_status);

    await updateStatusCertificate(
      userInscribed.user_id,
      userInscribed.Training.Course.id,
      isTrainingCompleted(userInscribed.Training, resAfterUpdateModule) ? 1 : 0,
    );

    setRefresh(refresh * -1);
  };
  return (
    <>
      <Typography variant="h4">{t("training_pages.assessor_checking_progress")}</Typography>
      {usersInscribed && (
        <TableComponent
          header={[
            { title: t("training_pages.user_id"), style: { width: "5%" } },
            { title: t("user") },
            { title: t("training_pages.crew") },
            { title: t("training.passed") },
            { title: t("training_pages.assessment_passed") },
          ]}
          renderChildren={(userInscribed, index) => (
            <TableRow key={index}>
              <TableCell>{userInscribed.user_id}</TableCell>
              <TableCell>{userInscribed.fullname}</TableCell>
              <TableCell>{userInscribed.companyName}</TableCell>
              <TableCell>{userInscribed.assessorPassed}</TableCell>

              <TableCell>
                {assessorPassed == 1 && (
                  <>
                    <StyledSwitch
                      disabled={userInscribed.assessor_passed === 1}
                      title={t("training_pages.assessor_passed")}
                      checked={userInscribed.assessor_passed === 1}
                      onChange={() => {
                        const valSwitch = userInscribed.assessor_passed === 1 ? 0 : 1;
                        onEventSwitch(userInscribed.id, "assessor_passed", valSwitch, userInscribed);
                      }}
                    />
                    {userInscribed.assessor_passed === 1 && (
                      <SignOffDateButton
                        trainingUserId={userInscribed.id}
                        field="assessor_passed"
                        date={userInscribed.assessor_passed_date}
                        onSaved={() => setRefresh(refresh * -1)}
                      />
                    )}
                  </>
                )}
              </TableCell>
            </TableRow>
          )}
          search={["user_id", "fullname", "companyName", "assessorPassed"]}
          pagination
          items={usersInscribed}
        />
      )}
      <Button title={t("back")} onClick={() => history.goBack()}>
        {t("back")}
      </Button>
    </>
  );
};

export default AssessorCheckingProgress;
